var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M24.499 68.5002C17.4997 66.0001 -4.0027 45.0001 15.499 20.0002M15.499 20.0002C24.8599 8 59.5 2.00011 66.5 38.0002M15.499 20.0002L35.4999 39.5004",
    stroke: "#999999",
    strokeWidth: 2.54,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    d: "M31.5 58.5002C37.5 49 57 35.5 75 58.5002C69.5 69.0001 48.5 82.0001 31.5 58.5002Z",
    stroke: "#999999",
    strokeWidth: 2.54,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 59,
    r: 7.73,
    stroke: "#999999",
    strokeWidth: 2.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlayer);
export default __webpack_public_path__ + "static/media/video-player.1515db5c5579898e4ced9766df789fc1.svg";
export { ForwardRef as ReactComponent };